import getBasePath from '../functions/api-resource';

const basePath = getBasePath('api', 'cache-manager');

const actions = {
  dropCache: { method: 'PUT', url: `${basePath}` },
};

export default (resource) => resource(`${basePath}`, {}, actions);
